var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("client-only", [_c("ImpersonationBanner")], 1),
      _vm._v(" "),
      _c("Header"),
      _vm._v(" "),
      _c("nuxt"),
      _vm._v(" "),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }